import React from 'react';

const FEATURES = [
  {
    number: '01',
    title: 'Conversation Search & Storage',
    description:
      'Upload JSON data of AI conversations for conversation semantic search.',
    inDevelopment: false,
  },
  {
    number: '02',
    title: 'Conversation Analysis',
    description:
      'Analyze your conversations to get detailed feedback and a score out of 100. The analysis modal contains sub-scores for communication clarity and other metrics, plus suggestions for how you can improve each prompt to achieve your goal more accurately.',
    inDevelopment: false,
  },
  {
    number: '03',
    title: 'Knowledge Webs',
    description:
      'Scan your conversations and light up knowledge webs with all of the concepts you talk about with AI. Visualize your understanding of a field of knowledge by seeing how much you know about each concept compared to the entire branch of knowledge.',
    inDevelopment: true,
  },
];

const HomePage: React.FC = () => {
  return (
    <main
      className="container mx-auto px-4 py-8"
      style={{ paddingTop: '7rem', maxWidth: '72rem' }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map((feature) => (
            <div
              key={feature.number}
              style={{
                backgroundColor: 'rgba(245, 245, 220, 0.05)',
                border: '1px solid rgba(245, 245, 220, 0.2)',
                borderLeft: '3px solid #ffffff',
                borderRadius: 0,
                padding: '1.5rem',
                minHeight: '14rem',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  gap: '0.75rem',
                  marginBottom: '1rem',
                }}
              >
                <span
                  style={{
                    color: 'rgba(255, 255, 255, 0.5)',
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    letterSpacing: '0.12em',
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  FEATURE #{feature.number}
                </span>
                {feature.inDevelopment && (
                  <span
                    style={{
                      fontSize: '0.65rem',
                      fontWeight: 600,
                      letterSpacing: '0.06em',
                      textTransform: 'uppercase',
                      color: '#ffffff',
                      border: '1px solid rgba(255, 255, 255, 0.4)',
                      padding: '0.2rem 0.5rem',
                      fontFamily: "'Inter', sans-serif",
                      whiteSpace: 'nowrap',
                    }}
                  >
                    In Development
                  </span>
                )}
              </div>
              <h3
                style={{
                  fontSize: '1rem',
                  fontWeight: 700,
                  color: '#ffffff',
                  marginBottom: '0.75rem',
                  fontFamily: "'Inter', sans-serif",
                  letterSpacing: '0.05em',
                  textTransform: 'uppercase',
                  lineHeight: 1.3,
                }}
              >
                {feature.title}
              </h3>
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.85)',
                  fontSize: '0.875rem',
                  lineHeight: 1.6,
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default HomePage;
